import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import ColorOption from "containers/Customizer/ColorOption";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";
// import Admission from './routes/admission';
// import Administration from './routes/administration';

class App extends React.Component {
  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <Tour/> */}

        <Sidebar userMode="Student" authUser={this.props.authUser} />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route
                  path={`${match.url}/dashboard`}
                  component={asyncComponent(() => import("./routes/dashboard"))}
                />

                <Route
                  path={`${match.url}/profile/`}
                  component={asyncComponent(() => import("./routes/profile"))}
                />

                <Route
                  path={`${match.url}/payment/`}
                  component={asyncComponent(() => import("./routes/payment"))}
                />

                {/* <Route
                  path={`${match.url}/learn`}
                  component={asyncComponent(() => import("./routes/learn"))}
                /> */}

                {/* Documents */}
                <Route
                  path={`${match.url}/documentdownload`}
                  component={asyncComponent(() =>
                    import("./routes/documents/docdownload")
                  )}
                />
                <Route
                  path={`${match.url}/documentupload`}
                  component={asyncComponent(() =>
                    import("./routes/documents/docupload")
                  )}
                />

                <Route
                  path={`${match.url}/paymenthistory/`}
                  component={asyncComponent(() =>
                    import("./routes/paymenthistory")
                  )}
                />
                <Route
                  path={`${match.url}/timetable`}
                  component={asyncComponent(() => import("./routes/timetable"))}
                />

                {/* Discussion Forum */}
                <Route
                  path={`${match.url}/LearningDiscussion`}
                  component={asyncComponent(() =>
                    import("./routes/discussions/learningdiscussion")
                  )}
                />

                <Route
                  path={`${match.url}/StudentDiscussion`}
                  component={asyncComponent(() =>
                    import("./routes/discussions/studentdiscussion")
                  )}
                />
                <Route
                  path={`${match.url}/GeneralDiscussion`}
                  component={asyncComponent(() =>
                    import("./routes/discussions/generaldiscussion")
                  )}
                />

                {/* Assignment */}
                <Route
                  path={`${match.url}/assignment`}
                  component={asyncComponent(() =>
                    import("./routes/assignment")
                  )}
                />

                {/* Courses */}

                <Route
                  path={`${match.url}/courseregistration/`}
                  component={asyncComponent(() =>
                    import("./routes/courses/CourseRegistration")
                  )}
                />

                <Route
                  path={`${match.url}/courseregistration/`}
                  component={asyncComponent(() =>
                    import("./routes/courses/CourseRegistration")
                  )}
                />

                <Route
                  path={`${match.url}/Result/`}
                  component={asyncComponent(() =>
                    import("./routes/result/index")
                  )}
                />
                <Route
                  path={`${match.url}/ReportCard/`}
                  component={asyncComponent(() =>
                    import("./routes/resltveiwer/index")
                  )}
                />

                <Route
                  path={`${match.url}/onlineClass/`}
                  component={asyncComponent(() =>
                    import("./routes/onlineLinks/onlineClass/index")
                  )}
                />
                <Route
                  path={`${match.url}/onlineExam/`}
                  component={asyncComponent(() =>
                    import("./routes/onlineLinks/onlineExam/index")
                  )}
                />
                <Route
                  path={`${match.url}/OnlineLectureNotes/`}
                  component={asyncComponent(() =>
                    import("./routes/onlineLinks/onlineDocument/index")
                  )}
                />

                <Route
                  path={`${match.url}/changepassword/`}
                  component={asyncComponent(() =>
                    import("./routes/changepassword")
                  )}
                />
                       {/* Transcript */}
                  <Route
                  path={`${match.url}/transcript/`}
                  component={asyncComponent(() =>
                    import("./routes/transcript/index")
                  )}
                />
                <Route
                  path={`${match.url}/unauthorized`}
                  component={asyncComponent(() =>
                    import("app/routes/extraPages/routes/401")
                  )}
                />
                <Route
                  component={asyncComponent(() =>
                    import("app/routes/extraPages/routes/404")
                  )}
                />

         
              </Switch>
            </div>
            <Footer />
          </main>
        </div>
        <ColorOption />
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  const authUser = auth.studentUser;
  return { drawerType, navigationStyle, horizontalNavPosition, authUser };
};
export default withRouter(connect(mapStateToProps)(App));
